/* eslint-disable react/prop-types */
import * as React from 'react';

class DropDownOption extends React.Component {
  render() {
    return (
      <li
        className="button-dropdown-element"
        onClick={(event) => {
          if (this.props.onClick) {
            this.props.onClick(event, this.props.data);
          }
        }}
      >
        {this.props.text || ''}
      </li>
    );
  }
}

export default class DropdownList extends React.Component {
  render() {
    return (
      <ul className="button-dropdown-container">
        {this.props.children
          .filter((option) => option.hidden !== true)
          .map((option, index) => (
            <DropDownOption
              key={index}
              text={option.text}
              data={option.data}
              onClick={option.onClick}
            />
          ))}
      </ul>
    );
  }
}
